import base from './base'

let controller = 'announcement'
let action = null

const Announcement = {
  async listPublic (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'tid',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    action = 'ListPublicAnnouncement'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: false,
      data: querys
    }
    return base.request(reqModel)
  },

  async list (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'tid',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    action = 'ListAnnouncement'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async add (request) {
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async update (request) {
    let id = request.tid
    if (!id) {
      throw new Error('提交数据不合法!id为空')
    }
    request.id = id
    action = `Update/${id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async detail (id) {
    if (!id) {
      throw new Error('id为空')
    }
    action = `Detail/${id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async delete (id) {
    if (!id) {
      throw new Error('id为空')
    }
    action = `Delete/${id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

}

export default Announcement